import { createApi } from 'unsplash-js';
import { logger } from './logger';
const unsplash = accessKey => createApi({ accessKey });
export const search = (accessKey, query, params = {}) => unsplash(accessKey).search.getPhotos({
    query,
    page: 1,
    perPage: 12,
    ...params,
});
export const random = (accessKey, params) => unsplash(accessKey).photos.getRandom({
    count: 12,
    featured: true,
    ...params,
});
export const downloadPhoto = (accessKey, downloadLocation) => unsplash(accessKey)
    .photos.trackDownload({
    downloadLocation,
})
    .then(res => res.response.url);
const toDataURL = url => {
    return fetch(url)
        .then(response => {
        return response.blob();
    })
        .then(blob => {
        return URL.createObjectURL(blob);
    });
};
export const downloadFile = async (document, src) => {
    try {
        const a = document.createElement('a');
        a.href = await toDataURL(src);
        a.download = '';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    catch (e) {
        logger.error('Error while downloading image', e.message);
    }
};
//# sourceMappingURL=unsplash.js.map